import { useNavigate } from "react-router"
import { Button } from "@components/Button"
import { LeftArrowIcon } from "@assets/icons"
import { PageNotFoundVector } from "./PageNotFoundVector"

export const PageNotFoundPageContent = () => {
    const navigate = useNavigate()
    const handleBackRedirection = () => navigate(-1)
    const handleHomeRedirection = () => navigate("/dashboard")

    return (
        <div className="grid grid-rows-11 md:grid-rows-1 grid-cols-1 md:grid-cols-2  flex-grow overflow-hidden ">
            <div className="row-span-5 md:order-2 flex items-center justify-center">
                <PageNotFoundVector className="h-auto w-[250px] xs:w-[300px] md:w-[550px]" />
            </div>
            <div className="row-span-6 md:order-1 flex flex-col justify-center gap-4 md:gap-11 p-6 md:p-20">
                <div className="flex flex-col gap-4 md:gap-8">
                    <h2 className="text-4xl xs:text-5xl  md:text-6xl font-extralight text-[var(--text-primary)] whitespace-pre-line md:whitespace-normal">
                        {`Oops! \n Page not found`}
                    </h2>
                    <p className="text-sm md:text-base lg:text-lg xl:text-xl text-[var(--text-primary)]">
                        Something went wrong. It looks like your requested page
                        could not be found. The link might be broken or the page
                        may have been removed.
                    </p>
                </div>
                <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
                    <Button
                        className="FLEX items-center w-full md:w-[200px]"
                        onClick={handleBackRedirection}
                    >
                        <LeftArrowIcon className="w-4 h-4 flex-shrink-0" />
                        BACK
                    </Button>
                    <Button
                        variant="secondary"
                        className="w-full md:w-[200px]"
                        onClick={handleHomeRedirection}
                    >
                        Home
                    </Button>
                </div>
            </div>
        </div>
    )
}
